import React, { useEffect, useState } from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import GetInTouch from '../components/GetInTouch';
import { getSettings } from '../lib/api';

const ContactUs = () => {
  const [s, setS] = useState({});
  useEffect(() => { getSettings().then(setS).catch(() => {}); }, []);
  const num = (s.whatsapp_number || '923001234567').replace(/[^0-9]/g, '');

  const info = [
    { icon: Phone, title: 'Phone', value: s.phone || '+92 300 1234567', href: `tel:${s.phone || ''}` },
    { icon: Mail, title: 'Email', value: s.email || 'info@nationallight.pk', href: `mailto:${s.email || ''}` },
    { icon: MapPin, title: 'Address', value: s.address || 'Lahore, Pakistan' },
    { icon: Clock, title: 'Working Hours', value: 'Mon - Sat: 9:00 AM - 8:00 PM' },
  ];

  return (
    <div>
      <PageHero title="Contact Us" subtitle="We'd love to hear from you. Reach out for product inquiries, bulk orders or support." />
      <section className="max-w-7xl mx-auto px-4 py-16 grid lg:grid-cols-3 gap-10">
        <div className="space-y-4">
          {info.map((c, i) => (
            <div key={i} className="bg-white rounded-2xl border border-gray-100 p-5 flex items-start gap-4">
              <div className="w-11 h-11 rounded-xl bg-[#eaf6ec] flex items-center justify-center shrink-0"><c.icon size={20} className="text-[#0f7a37]" /></div>
              <div>
                <div className="font-head font-semibold text-[#14181b]">{c.title}</div>
                <div className="text-sm text-gray-600 mt-0.5">{c.value}</div>
              </div>
            </div>
          ))}
          <a href={`https://wa.me/${num}`} target="_blank" rel="noopener noreferrer"
            className="nl-btn w-full bg-[#25D366] hover:bg-[#1eb457] text-white py-3.5"><MessageCircle size={20} /> Chat on WhatsApp</a>
        </div>
        <div className="lg:col-span-2">
          <div className="bg-white rounded-2xl border border-gray-100 p-8">
            <h2 className="font-head text-2xl font-extrabold text-[#14181b] mb-2">Send us a Message</h2>
            <p className="text-gray-500 text-sm mb-6">Fill out the form and we'll get back to you within 24 hours.</p>
            <GetInTouch />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;
